import React from 'react';
import Header from './Header/Header';

export default function Layout({ children }: { children: JSX.Element }) {
  return (
    <>
      <Header />
      <main className='container mt-3'>{children}</main>
    </>
  );
}
